export default __webpack_public_path__ + "img/a530ddf670a8bc1930f79248e8458627.svg";